import React, { useState, useEffect } from "react";
import {
  ServicesContainer,
  Heading,
  Subtitle,
  MintingButton,
  Input2,
  Welcome,
  DirectionFlex,
  NavBtn,
  NavBtnLink1,
  MintBtnCont,
} from "./ServicesElements";
// import { getBlockchainData } from "../../libs/metamask-connection";
// import { getContractNft } from "../../libs/smart-contracts-config";

import Mint from "../../images/Mint Button.png";
import { publicMint } from "../../libs/apis";
const Services = () => {
  const [mintCount, setMintCount] = useState(0);
  // const [loading, setLoading] = useState(false);
  // const [minted, setMinted] = useState(0);
  // const [item, setItem] = useState(0);

  const _minted = async () => {
    // const mint = getContractNft();
    // console.log("presale", mint);
    // const remainingSnow = await mint.methods.circulatingSupply().call();
    // console.log("remainingSnow", itemPrice);
    // return setMinted(remainingSnow);
  };
  const _itemPrices = async () => {
    // const mint = getContractNft();
    // const itemPrice = await mint.methods.itemPrice().call();
    // return setItem(itemPrice / 10 ** 18);
  };

  useEffect(() => {
    _minted();
    _itemPrices();
    setInterval(() => {
      _minted();
      _itemPrices();
    }, 3000);
  }, []);

  return (
    <ServicesContainer>
      <Welcome>
        <DirectionFlex>
          <Heading>Market</Heading>

          <div style={{ flexDirection: "column", width: "100%" }}>
            {/* <Subtitle>Presale PRICE : 0.06 Eth</Subtitle> */}
            {/* <Subtitle>MINT 10 AND GET THE 11th FOR FREE!</Subtitle>
            <Subtitle>MINT PROGESS : {minted}/10000</Subtitle> */}
            <Subtitle>Presale Coming Soon!</Subtitle>
            {/* <Subtitle>Presale PROGESS : 0/1000</Subtitle> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                width: "100%",
                alignItems: "center",
              }}
            >
              <MintBtnCont>
                <NavBtn>
                  <NavBtnLink1
                    onClick={() => {
                      setMintCount(mintCount - 1);
                    }}
                    disabled={mintCount === 1 ? true : false}
                  >
                    -
                  </NavBtnLink1>
                </NavBtn>
                <NavBtn style={{ width: "37%" }}>
                  <Input2
                    type="number"
                    id="quantity"
                    name="quantity"
                    min="1"
                    max="10"
                    // disabled={true}
                    value={mintCount}
                    onChange={(e) => setMintCount(e.target.value)}
                  />
                </NavBtn>
                <NavBtn>
                  <NavBtnLink1
                    onClick={() => {
                      setMintCount(mintCount + 1);
                    }}
                    disabled={mintCount === 10 ? true : false}
                  >
                    +
                  </NavBtnLink1>
                </NavBtn>
              </MintBtnCont>

              <MintingButton
                src={Mint}
                alt="loading"
                onClick={() => {
                  publicMint(() => { } ,mintCount)

                  // console.log("checkingValue :" + loading);
                  // getBlockchainData(async (account, web3) => {
                  //   if (!mintCount || isNaN(mintCount)) {
                  //     alert("Enter some nft quantity to buy");
                  //     return;
                  //   }

                  //   const nft = getContractNft(web3);
                  //   // const price = web3.utils.fromWei(
                  //   //   await nft.methods.itemPrice().call(),
                  //   // );
                  //   const price = web3.utils.fromWei(
                  //     await nft.methods.itemPrice().call()
                  //   );

                  //   const _howMany = Number(mintCount);
                  //   const totalPrice = web3.utils.toWei(
                  //     (Number(price) * _howMany).toString()
                  //   );

                  //   // here we use code from twitter post of nft
                  //   // const purchase = nft.methods.purchaseTokens(mintCount);
                  //   const purchase = nft.methods.purchaseTokens(mintCount);
                  //   let options = {
                  //     from: account,
                  //     gas: "0",
                  //     value: totalPrice,
                  //   };
                  //   try {
                  //     const estimateGas = Math.trunc(
                  //       await purchase.estimateGas(options)
                  //     );
                  //     options = {
                  //       ...options,
                  //       gas: "" + estimateGas,
                  //     };
                  //   } catch (e) {
                  //     let msg = null;

                  //     try {
                  //       let a = e.message;
                  //       msg = JSON.parse(
                  //         a.substring(a.indexOf("{"), a.lastIndexOf("}") + 1)
                  //       ).message;
                  //       msg = msg.replace("err: ", "");
                  //       msg = msg.replace("execution reverted: ", "");
                  //     } catch (eiii) {}

                  //     if (!msg || msg === undefined) {
                  //       msg = "Insufficient funds.";
                  //     }

                  //     alert(msg);
                  //     return;
                  //   }

                  //   try {
                  //     setLoading(true);
                  //     await purchase.send(options).on("confirmation", (i) => {
                  //       //here
                  //       if (i === 0) {
                  //         setLoading(false);
                  //         if (
                  //           window.confirm(
                  //             `Welcome to the Trippy Chicks Club ! Go check out your Trippy Chicks on opensea`
                  //           )
                  //         ) {
                  //           window.location.href = `https://testnets.opensea.io/users/avalanche/${account}`;
                  //         }
                  //       }
                  //     });
                  //   } catch (e) {
                  //     setLoading(false);
                  //     alert(e.message);
                  //   }
                  // }, true);
                }}
              />
            </div>
          </div>
        </DirectionFlex>

        {/* <Welcomeimg src={Faq1} alt='loading' /> */}
      </Welcome>
    </ServicesContainer>
  );
};

export default Services;
